import {TransactionStatus} from '@usedapp/core';
import {useEffect, useMemo, useState} from 'react';

export default function useTransactionLoading(status: TransactionStatus) {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (
            [undefined, 'None', 'Success', 'Fail', 'Exception'].includes(
                status.status,
            )
        ) {
            setLoading(false);
        } else {
            setLoading(true);
        }
    }, [status]);

    return useMemo(() => loading, [loading]);
}
